import { Box, Stack, Typography } from '@mui/material';
import styles from '../../../assets/css/components/Lobby.module.css';
import { buildHsUrlWithToken } from '../../../Utils/SessionUrlUtils';
import { isMobile } from 'react-device-detect';

export interface Game {
    thumbnail: string;
    title: string;
    link: string;
    providerIcon: string;
    providerName: string;
}

interface GameSectionProps {
    title: string;
    games: Game[];
    containerClassName?: string;
    gameBoxClassName?: string;
    thumbnailClassName?: string;
    titleClassName?: string;
}

export default function GameSection({ 
    title, 
    games, 
    containerClassName = styles.homeLobbyGameContainer,
    gameBoxClassName = styles.homeLobbyGameBox,
    thumbnailClassName = styles.homeLobbyGameBoxThumbnail,
    titleClassName = styles.homeLobbyGameBoxTitle
}: GameSectionProps) {
    return (
        <Box style={{ width: '100%' }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: '0.5rem' }}>
                <Typography style={{ fontSize: '14px', fontWeight: 600, color: '#FFFFFF' }}>
                    {title}
                </Typography>
            </Stack>
            <Stack className={containerClassName} direction="row" justifyContent="start" alignItems="center" gap={2} sx={{ mb: isMobile ? 0 : '1rem' }}>
                {games.map((game, index) => (
                    <Stack key={`${game.title}-${index}`} className={gameBoxClassName}>
                        <Box 
                            className={thumbnailClassName} 
                            style={{ backgroundImage: `url(${game.thumbnail})` }} 
                        >
                            <Typography className={titleClassName} p={1}>
                                {game.title}
                            </Typography>
                        </Box>
                        <Typography style={{ fontSize: '10px', fontWeight: 700, color: '#9A9AA0', marginTop: '0.25rem' }}>
                            <img 
                                src={game.providerIcon} 
                                alt={`${game.providerName} Icon`}
                                height={13} 
                                style={{ marginRight: '0.25rem', verticalAlign: 'text-top' }} 
                            /> 
                            {game.providerName}
                        </Typography>
                    </Stack>
                ))}
            </Stack>
        </Box>
    );
}
